import alt from 'epic-react-common/src/alt';

export default alt;
